module.exports = __webpack_public_path__ + "img/vpromoicon.a0a29a85.png";